module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    on: {
      "click": _vm.select,
      "keydown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.select($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-71fb3b2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectableGridRow.vue
// module id = 1694
// module chunks = 1